import MessagingPreferences from './MessagingPreferences.component';

export default MessagingPreferences;
